export interface NewsArticle {
  id: string;
  title: string;
  excerpt: string;
  category: string;
  categorySlug: string;
  coverImage: string;
  coverSeq: string;
  author: string;
  date: string;
  views: number;
  isHot: boolean;
  isFeatured: boolean;
  tags: string[];
}

export interface CategoryInfo {
  name: string;
  slug: string;
  icon: string;
  description: string;
}

export const categories: CategoryInfo[] = [
  { name: '明星八卦', slug: 'mingxing-bagua', icon: 'ri-star-line', description: '娱乐圈最新明星动态与八卦爆料' },
  { name: '网红黑料', slug: 'wanghong-heiliao', icon: 'ri-user-smile-line', description: '网红圈最新翻车实录与黑料合集' },
  { name: '社会热点', slug: 'shehui-redian', icon: 'ri-fire-line', description: '社会热门事件深度追踪与解读' },
  { name: '每日大赛', slug: 'meiri-dasai', icon: 'ri-trophy-line', description: '每日最热门吃瓜大赛实时更新' },
];

export const newsArticles: NewsArticle[] = [
  {
    id: '1',
    title: '某顶流男星深夜密会神秘女子，酒店共度8小时引热议',
    excerpt: '据知情人士透露，该男星近日被拍到与一名神秘女子深夜进出某五星级酒店，两人行为亲密，引发粉丝热议。',
    category: '明星八卦',
    categorySlug: 'mingxing-bagua',
    coverImage: 'https://readdy.ai/api/search-image?query=Celebrity%20paparazzi%20night%20scene%20outside%20luxury%20hotel%2C%20dark%20moody%20atmosphere%2C%20dramatic%20lighting%2C%20cinematic%20photography%20style%2C%20blurred%20figures%20entering%20hotel%2C%20urban%20night%20vibe%2C%20warm%20street%20lamps%20against%20dark%20sky%2C%20mysterious%20and%20provocative%20tone&width=800&height=600&seq=news-cover-01&orientation=landscape',
    coverSeq: 'news-cover-01',
    author: '吃瓜小编',
    date: '2026-06-28',
    views: 128000,
    isHot: true,
    isFeatured: true,
    tags: ['顶流', '恋情', '酒店'],
  },
  {
    id: '2',
    title: '知名带货网红涉嫌虚假宣传，直播间三百万观众集体维权',
    excerpt: '某拥有千万粉丝的带货网红被曝涉嫌虚假宣传，其推荐的多款产品被检测出质量问题，引发大规模消费者维权事件。',
    category: '网红黑料',
    categorySlug: 'wanghong-heiliao',
    coverImage: 'https://readdy.ai/api/search-image?query=Live%20streaming%20influencer%20studio%20with%20products%20displayed%2C%20dramatic%20contrast%20lighting%2C%20consumer%20products%20scattered%2C%20tense%20atmosphere%2C%20cinematic%20documentary%20style%2C%20warm%20red%20accents%2C%20social%20media%20controversy%20theme&width=800&height=600&seq=news-cover-02&orientation=landscape',
    coverSeq: 'news-cover-02',
    author: '黑料追踪',
    date: '2026-06-27',
    views: 256000,
    isHot: true,
    isFeatured: false,
    tags: ['网红', '虚假宣传', '维权'],
  },
  {
    id: '3',
    title: '某选秀节目选手被曝学历造假，节目组紧急声明回应',
    excerpt: '热门选秀节目中一位人气选手被网友扒出学历造假，涉及名校背景虚构，节目组已发布紧急声明表示将展开调查。',
    category: '社会热点',
    categorySlug: 'shehui-redian',
    coverImage: 'https://readdy.ai/api/search-image?query=Talent%20show%20stage%20with%20dramatic%20spotlight%2C%20contestant%20silhouette%2C%20dark%20background%20with%20warm%20stage%20lights%2C%20tension%20and%20drama%20atmosphere%2C%20theatrical%20lighting%2C%20controversy%20mood%2C%20entertainment%20industry%20expose%20theme&width=800&height=600&seq=news-cover-03&orientation=landscape',
    coverSeq: 'news-cover-03',
    author: '学术打假',
    date: '2026-06-27',
    views: 189000,
    isHot: true,
    isFeatured: false,
    tags: ['选秀', '学历造假', '声明'],
  },
  {
    id: '4',
    title: '娱乐圈模范夫妻疑似婚变，双方已取关社交账号',
    excerpt: '曾被粉丝称为娱乐圈模范夫妻的两位艺人近日被曝疑似婚变，双方社交账号已互相取关，引发网友疯狂猜测。',
    category: '明星八卦',
    categorySlug: 'mingxing-bagua',
    coverImage: 'https://readdy.ai/api/search-image?query=Celebrity%20couple%20distant%20and%20cold%20atmosphere%2C%20split%20screen%20composition%2C%20dark%20moody%20tones%2C%20emotional%20distance%20theme%2C%20dramatic%20lighting%2C%20romance%20turning%20cold%2C%20entertainment%20news%20vibe&width=800&height=600&seq=news-cover-04&orientation=landscape',
    coverSeq: 'news-cover-04',
    author: '吃瓜小编',
    date: '2026-06-26',
    views: 312000,
    isHot: true,
    isFeatured: true,
    tags: ['婚变', '明星夫妻', '取关'],
  },
  {
    id: '5',
    title: '短视频平台头部网红税务问题被调查，涉及金额超千万',
    excerpt: '据税务部门消息，某短视频平台头部网红因涉嫌偷税漏税被立案调查，涉及金额超千万元，平台方已配合调查。',
    category: '网红黑料',
    categorySlug: 'wanghong-heiliao',
    coverImage: 'https://readdy.ai/api/search-image?query=Financial%20investigation%20scene%20with%20documents%20and%20calculator%2C%20dark%20office%20atmosphere%2C%20dramatic%20shadows%2C%20tax%20audit%20theme%2C%20serious%20mood%2C%20professional%20photography%2C%20warm%20amber%20desk%20lamp%20glow&width=800&height=600&seq=news-cover-05&orientation=landscape',
    coverSeq: 'news-cover-05',
    author: '黑料追踪',
    date: '2026-06-26',
    views: 201000,
    isHot: false,
    isFeatured: false,
    tags: ['网红', '税务', '调查'],
  },
  {
    id: '6',
    title: '某综艺节目录制现场爆发激烈冲突，明星嘉宾愤然离场',
    excerpt: '热门综艺节目录制现场爆发激烈冲突，两位明星嘉宾因观点不合发生口角，其中一位愤然离场，节目组紧急暂停录制。',
    category: '每日大赛',
    categorySlug: 'meiri-dasai',
    coverImage: 'https://readdy.ai/api/search-image?query=TV%20show%20recording%20studio%20with%20empty%20chairs%20and%20dramatic%20lighting%2C%20conflict%20atmosphere%2C%20abandoned%20microphones%2C%20tense%20mood%2C%20warm%20spotlight%20on%20empty%20stage%2C%20behind%20the%20scenes%20drama&width=800&height=600&seq=news-cover-06&orientation=landscape',
    coverSeq: 'news-cover-06',
    author: '现场直击',
    date: '2026-06-25',
    views: 445000,
    isHot: true,
    isFeatured: true,
    tags: ['综艺', '冲突', '离场'],
  },
  {
    id: '7',
    title: '知名导演深夜发文暗讽某流量明星，粉丝团集体出征',
    excerpt: '某知名导演深夜在社交平台发文，疑似暗讽某流量明星演技差还耍大牌，引发该明星粉丝大规模出征导演评论区。',
    category: '明星八卦',
    categorySlug: 'mingxing-bagua',
    coverImage: 'https://readdy.ai/api/search-image?query=Film%20director%20silhouette%20in%20dark%20room%20with%20phone%20glow%2C%20social%20media%20conflict%20theme%2C%20dramatic%20noir%20lighting%2C%20late%20night%20atmosphere%2C%20controversy%20and%20tension%2C%20cinematic%20composition&width=800&height=600&seq=news-cover-07&orientation=landscape',
    coverSeq: 'news-cover-07',
    author: '吃瓜小编',
    date: '2026-06-25',
    views: 178000,
    isHot: false,
    isFeatured: false,
    tags: ['导演', '流量明星', '暗讽'],
  },
  {
    id: '8',
    title: '知名网红被前助理曝光私生活混乱，聊天记录流出',
    excerpt: '某知名网红的前助理在社交平台曝光了大量聊天记录，揭露该网红私生活混乱、对待员工态度恶劣等多项黑料。',
    category: '网红黑料',
    categorySlug: 'wanghong-heiliao',
    coverImage: 'https://readdy.ai/api/search-image?query=Leaked%20chat%20messages%20on%20phone%20screen%2C%20dark%20background%2C%20dramatic%20lighting%2C%20whistleblower%20theme%2C%20expose%20and%20revelation%20atmosphere%2C%20digital%20screenshot%20aesthetic%2C%20warm%20screen%20glow%20in%20darkness&width=800&height=600&seq=news-cover-08&orientation=landscape',
    coverSeq: 'news-cover-08',
    author: '黑料追踪',
    date: '2026-06-24',
    views: 389000,
    isHot: true,
    isFeatured: false,
    tags: ['网红', '聊天记录', '曝光'],
  },
  {
    id: '9',
    title: '某品牌代言人涉嫌不当言论，品牌方连夜解约删博',
    excerpt: '某知名品牌代言人因在私人聚会上发表不当言论被曝光，品牌方连夜发布解约声明并删除所有相关宣传内容。',
    category: '社会热点',
    categorySlug: 'shehui-redian',
    coverImage: 'https://readdy.ai/api/search-image?query=Brand%20billboard%20being%20removed%20at%20night%2C%20dramatic%20urban%20scene%2C%20dark%20sky%20with%20city%20lights%2C%20crisis%20management%20theme%2C%20corporate%20drama%2C%20warm%20street%20lamps%2C%20cinematic%20night%20photography&width=800&height=600&seq=news-cover-09&orientation=landscape',
    coverSeq: 'news-cover-09',
    author: '品牌观察',
    date: '2026-06-24',
    views: 234000,
    isHot: false,
    isFeatured: false,
    tags: ['代言人', '解约', '不当言论'],
  },
  {
    id: '10',
    title: '年度吃瓜大赛TOP10揭晓，第一名让所有人都没想到',
    excerpt: '2026上半年吃瓜大赛TOP10榜单正式揭晓，从明星塌房到网红翻车，今年的大瓜一个比一个劲爆，第一名结果出人意料。',
    category: '每日大赛',
    categorySlug: 'meiri-dasai',
    coverImage: 'https://readdy.ai/api/search-image?query=Award%20ceremony%20stage%20with%20golden%20trophy%20and%20dramatic%20spotlight%2C%20dark%20background%2C%20celebration%20yet%20dramatic%20atmosphere%2C%20warm%20golden%20glow%2C%20entertainment%20awards%20theme%2C%20cinematic%20lighting&width=800&height=600&seq=news-cover-10&orientation=landscape',
    coverSeq: 'news-cover-10',
    author: '榜单发布',
    date: '2026-06-23',
    views: 567000,
    isHot: true,
    isFeatured: true,
    tags: ['排行榜', '年度总结', '吃瓜大赛'],
  },
  {
    id: '11',
    title: '某女星出席活动被拍满脸疲态，粉丝心疼喊话经纪公司',
    excerpt: '某当红女星出席品牌活动时被拍到满脸疲态，黑眼圈明显，粉丝纷纷在社交平台喊话经纪公司减少其工作安排。',
    category: '明星八卦',
    categorySlug: 'mingxing-bagua',
    coverImage: 'https://readdy.ai/api/search-image?query=Female%20celebrity%20at%20red%20carpet%20event%20with%20paparazzi%20flashes%2C%20tired%20expression%2C%20dramatic%20night%20event%20atmosphere%2C%20glamour%20and%20exhaustion%20contrast%2C%20warm%20flash%20photography%2C%20entertainment%20news%20style&width=800&height=600&seq=news-cover-11&orientation=landscape',
    coverSeq: 'news-cover-11',
    author: '吃瓜小编',
    date: '2026-06-23',
    views: 145000,
    isHot: false,
    isFeatured: false,
    tags: ['女星', '疲态', '粉丝'],
  },
  {
    id: '12',
    title: '知名美食博主被曝后厨卫生堪忧，网友翻出旧视频佐证',
    excerpt: '一位拥有数百万粉丝的美食博主被曝其拍摄场地的后厨卫生状况堪忧，网友翻出多期旧视频中的蛛丝马迹作为证据。',
    category: '网红黑料',
    categorySlug: 'wanghong-heiliao',
    coverImage: 'https://readdy.ai/api/search-image?query=Messy%20kitchen%20behind%20the%20scenes%20of%20food%20video%20shooting%2C%20contrast%20between%20beautiful%20food%20and%20dirty%20background%2C%20dark%20atmosphere%2C%20investigative%20journalism%20style%2C%20dramatic%20reveal%2C%20food%20safety%20theme&width=800&height=600&seq=news-cover-12&orientation=landscape',
    coverSeq: 'news-cover-12',
    author: '黑料追踪',
    date: '2026-06-22',
    views: 198000,
    isHot: false,
    isFeatured: false,
    tags: ['美食博主', '卫生', '曝光'],
  },
];

export const hotTags: string[] = [
  '顶流塌房', '网红翻车', '明星恋情', '综艺现场', '品牌解约',
  '学历造假', '税务风波', '私生饭', '聊天记录', '年度大瓜',
];

export const siteInfo = {
  name: '51黑料吃瓜网',
  description: '汇聚全网最新最热的明星八卦、网红黑料与社会热点，打造最全免费吃瓜资源平台。实时追踪，不打烊在线观看，每日大赛爆料第一时间送达。',
  features: [
    {
      icon: 'ri-flashlight-line',
      title: '实时追踪',
      description: '7x24小时不间断追踪娱乐圈最新动态，第一时间推送热点爆料，让你永远快人一步。',
    },
    {
      icon: 'ri-shield-check-line',
      title: '真实爆料',
      description: '严格核实信息来源，多方交叉验证，确保每一条爆料都有据可查，拒绝虚假谣言。',
    },
    {
      icon: 'ri-group-line',
      title: '吃瓜社区',
      description: '数百万吃瓜群众聚集地，实时讨论最新大瓜，弹幕互动、评论区battle，吃瓜氛围拉满。',
    },
    {
      icon: 'ri-global-line',
      title: '全网聚合',
      description: '聚合微博、抖音、小红书等全平台热点内容，一站在手，全网大瓜尽在掌握。',
    },
  ],
};